import $ from 'jquery';
import axios from 'axios';

export const CommonConfig=(()=>{
	return {
		'isDebug':'development' == process.env.NODE_ENV,
		'siteName': process.env.REACT_APP_SITE_NAME,
		'hostUrl': process.env.REACT_APP_API_URL,
	};
})();

export const CommonValue={
	'value':{},
	/*
	'get':async (key)=>{
		return JSON.parse(localStorage.getItem(key));
	},
	*/
	'get':(key)=>{
		try
		{
			return JSON.parse(localStorage.getItem(key));
		}
		catch(e)
		{
			return localStorage.getItem(key);
		}
	},
	'set':(key,value)=>{
		if(typeof(value)=='object')
			value=JSON.stringify(value);
		
		//this.value[key]=value;
		localStorage.setItem(key,value);
	},
	'remove':(key)=>{
		//delete(this.value[key]);
		localStorage.clear(key);
	},
};

export const url = (url,params) =>{
	var preUrl=CommonConfig.isDebug?CommonConfig.hostUrl:CommonConfig.hostUrl;
	url=preUrl+url;
	
	url+='?';
	for(var i in params)
	{
		url+=i+'='+params[i]+'&';
	}
	url=url.substr(0,url.length-1);
	return url;
};

export const authUrl = (c,params) =>{
	var _url='/cqs-student';
	_url+=c;
	
	return url(_url,params);
};

export const pcUrl = (c,params) =>{
	var _url='/cqs-student/api';
	_url+=c;
	
	return url(_url,params);
};

export const ngUrl = (c,a,params,isQuery)=>{
	if(typeof(a)=='object')
	{
		isQuery=params;
		params=a;
		a='';
	}
	//let url='#/'+c;
	let url='/'+c;
	if(a!=undefined && a)
		url+='/'+a;
	
	if(isQuery)
	{
		url+='?';
		for(let i in params)
		{
			url+=i+'='+params[i]+'&';
		}
		url=url.substr(0,url.length-1);
	}
	else
	{
		for(let i in params)
		{
			url+='/'+params[i];
		}
	}
	
	return url;
};

export const httpPost = (url,param,method,config)=> {
	if(param==undefined)
		param={};
	if(!method)
		method = 'POST';
	if(!config)
		config = {};
	let rawCode = config.rawCode;
	let rawResponse = config.rawResponse;
	let hideAjax = config.hideAjax;
	let token = CommonValue.get('token');
	
	//转换为json格式
	//let data=JSON.stringify(param);
	
	return new Promise((resolve,reject)=>{
		if(!hideAjax) {
			global.setRootState({
				'isLoading':true,
			});
		}
		
		let headers = {
			"Content-Type": "application/json",
			"Accept": "application/json",
		};
		if(param instanceof FormData)
			headers['Content-Type'] = 'multipart/form-data';
		if(token)
			headers['token'] = token;
		
		axios({
			url: url,
			method: method,
			data:param,
			headers: headers,
		})
		.then(response =>{
			let data = response.data;
			
			if(!hideAjax)
				global.setRootState({ 'isLoading':false });
			if(rawCode)
			{
				resolve(data);
				return;
			}
			
			if(data.code!=0)
			{
				if(data.code == 301)
				{
					let cardNo = data.data.cardNo;
					CommonValue.set('cardNo', cardNo);
					window.location.href = ngUrl('register');
					return;
				}

				//未登录
				if(data.code == 401)
				{
					/*
					let url = window.location.href;
					url = url.split('#');
					url = url[1];
					*/
					let url = window.location.href;
					url = url.split('/');
					url.splice(0,3);
					url = '/'+url.join('/');
					
					if(!CommonValue.get('login_redirect'))
						CommonValue.set('login_redirect',url);
					window.location.href=ngUrl('login');
					return;
				}
				
				message(data.msg);
				reject(data);
				return;
			}
			
			if(rawResponse)
				resolve(data);
			else
				resolve(data.data);
		})
		.catch(error=>{
			if(!hideAjax)
				global.setRootState({ 'isLoading':false });
			
			let response=error.response;
			let data=response.data;
			if(rawCode)
			{
				reject(data);
				return;
			}
			if(data)
			{
				if(data.code == 401)
				{
					let url = window.location.href;
					url = url.split('#');
					url = url[1];
					
					if(!CommonValue.get('login_redirect'))
						CommonValue.set('login_redirect',url);
					window.location.href=ngUrl('login');
					return;
				}
				else
					message(data.msg);
			}
			else
				message('接口请求错误');
			
			reject();
		});
		
	});

	/*
	return new Promise((resolve,reject)=>{
		if(!hideAjax)
			setRootState({
				'isLoading':true,
			});
		let xhr = new XMLHttpRequest();
		xhr .onreadystatechange = e => {
			if (xhr.readyState !== 4)
			{
				return;
			}
			if(!hideAjax)
				setRootState({
					'isLoading':false,
				});
			if (xhr.status === 200)
			{
				let data=JSON.parse(xhr.responseText);
				if(data.code!=0)
				{
					alert(data.message);
					return;
				}

				resolve(data.data);
			}
			else
			{
				reject(xhr.responseText);
			}
		};
		xhr.open("POST", url);
		xhr.setRequestHeader("Content-Type","application/json");
		data=JSON.stringify(param);
		xhr.send(data);
	});
	*/
};

/*
export const alert = (message)=> {
	return showModal(message);
};
export const confirm = (message)=> {
	return showModal(message,true);
};
export const showModal = (message,showConfirm)=> {
	return new Promise((resolve,reject)=>{
		let modalList = global.getRootState('modalList');
		if(modalList.length)
		{
			let modalInfo = modalList[modalList.length -1];
			modalInfo.setState({
				'active':false,
			});
		}
		let modalScope = {
			'show':true,
			'title':'提示',
			'message':message,
			'cancel':showConfirm?reject:null,
			'confirm':resolve,
		};
		global.setRootState({ 'modalScope':modalScope })
			.then(()=>{
				window.setTimeout(()=>{
					modalScope.showModal = true;
					global.setRootState({
						'modalScope':modalScope,
					});
				},50);
			});
	});
};
*/

export const message = (message,type)=> {
	if(!type) type = 'error';
	
	let toastScope = {
		'show':true,
		'type':type,
		'message':message,
	};
	global.setRootState({
		'toastScope':toastScope,
	});
	
	return new Promise((resolve,reject)=>{
		window.setTimeout(()=>{
			toastScope = {
				'show':false,
			};
			global.setRootState({
				'toastScope':toastScope,
			});
			
			resolve();
		},3000);
	});
};

/*
export const notify = (message)=> {
	return new Promise((resolve,reject)=>{
		let notifyScope = global.getRootState('notifyScope');
		if(notifyScope.timer) window.clearTimeout(notifyScope.timer);

		notifyScope = {
			'show':true,
			'message':message,
			'timer':null,
		};
		notifyScope.timer = window.setTimeout(()=>{
			notifyScope.showNotify = false;
			global.setRootState({ 'notifyScope':notifyScope, })
			.then(()=>{
				window.setTimeout(()=>{
					notifyScope.show = false;
					global.setRootState({
						'notifyScope':notifyScope,
					});
				},1000);
			});
		},2000);
		
		global.setRootState({ 'notifyScope':notifyScope })
			.then(()=>{
				window.setTimeout(()=>{
					notifyScope.showNotify = true;
					global.setRootState({
						'notifyScope':notifyScope,
					});
				},50);
			});

	});
};
*/

export const java2c = (name) => {
	let length=name.length;
	let arr=[];
	let i,j;
	let str;
	
	for(i=0,j=0;i<length;i++)
	{
		if( name[i]>='A' && name[i]<='Z' && i!=0 )
		{
			str=name.substr(j,i-j);
			arr.push(str);
			j=i;
		}
	}
	
	str=name.substr(j,i-j);
	arr.push(str);
	name=arr.join('_').toLowerCase();
	return name;
}

export const c2java = (name) => {
	let temp=name.split('_');
	name='';
	temp.forEach((str)=>{
		str=str.replace(str[0],str[0].toUpperCase());
		name+=str;
	});
	
	return name;
}

export const c2camel = (name) => {
	let temp=name.split('_');
	name='';
	temp.forEach((str,index)=>{
		if(index!=0)
			str=str.replace(str[0],str[0].toUpperCase());
		
		name+=str;
	});
	
	return name;
}

export const scrollTop = () => {
	$('html ,body').animate({scrollTop: 0}, 300);
	//$('html ,body').animate({scrollTop: 0}, 10);
	//$('#page-wrapper').animate({scrollTop: 0}, 300);
}

export const parseQuery = (search) => {
	search=search.replace('?','').split('&');
	let query={};
	search.forEach((str)=>{
		str=str.split('=');
		query[str[0]]=str[1];
	});
	return query;
}

export const parseTime = (time) => {
	return formatTime('Y-m-d H:i:s',time);
}

export const formatTime = (format,time) => {
	if(time!=undefined)
		var t=new Date(time*1000);
	else
		var t=new Date();
	
	let str=format;
	str=str.replace('Y',formatNumber(t.getFullYear()));
	str=str.replace('m',formatNumber((t.getMonth()+1)));
	str=str.replace('d',formatNumber(t.getDate()));
	str=str.replace('H',formatNumber(t.getHours()));
	str=str.replace('i',formatNumber(t.getMinutes()));
	str=str.replace('s',formatNumber(t.getSeconds()));
	return str;
}

export const formatVideoTime = (seconds) => {
	let hours = Math.floor(seconds / (60*60));
	seconds = seconds % (60*60);
	let minutes = Math.floor(seconds / (60));
	seconds = seconds % (60);
	
	if(hours > 0)
		return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
	else
		return `${formatNumber(minutes)}:${formatNumber(seconds)}`;
}

export const formatNumber = (num) => {
	if(num<10) num='0'+num;
		return num;
}

export const getQuery = (key) => {
	let url=window.location.href;
	
	url=url.split('?');
	if(url.length<=1 || url[1]=='') return key?'':{};
	var query=url[1];
	query=query.split('&');
	var params={};
	var c,a;
	
	for(var i=0;i<query.length;i++)
	{
		if(query[i]=='' ) continue;
		query[i]=query[i].split('=');
		params[query[i][0]]=query[i][1];
	}
	
	if(key!=undefined)
		return params[key];
	else
		return params;
}

export const strlen = (str) => {
	let len = 0;
	for (let i=0; i<str.length; i++) {
		let c = str.charCodeAt(i);
		//单字节加1
		if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
			len++;
		}
		else {
			len+=2;
		}
	}
	return len;
}

export const getScrollbarWidth = () => {
	var odiv = document.createElement('div'),//创建一个div
		styles = {
			width: '100px',
			height: '100px',
			overflowY: 'scroll'//让他有滚动条
		}, i, scrollbarWidth;
	for (i in styles) odiv.style[i] = styles[i];
	document.body.appendChild(odiv);//把div添加到body中
	scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
	odiv.remove();//移除创建的div
	return scrollbarWidth;//返回滚动条宽度
}

export const debounce =  (func, wait, immediate) => {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export const accDiv = (arg1,arg2) => {
    var t1=0,t2=0,r1,r2;
    try{t1=arg1.toString().split(".")[1].length}catch(e){}
    try{t2=arg2.toString().split(".")[1].length}catch(e){}
        r1=Number(arg1.toString().replace(".",""))
        r2=Number(arg2.toString().replace(".",""))
        return (r1/r2)*Math.pow(10,t2-t1);
};

export const accMul = (arg1,arg2) => {
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
};

export const accAdd = (arg1,arg2) => {
    var r1,r2,m;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2))
    return (arg1*m+arg2*m)/m
};

export const getSystem = ()=>{
	var OS = '';
	var OSArray = {};
	var UserAgent = navigator.userAgent.toLowerCase();
	OSArray.Windows = (navigator.platform == 'Win32') || (navigator.platform == 'Windows');
	OSArray.Mac = (navigator.platform == 'Mac68K') || (navigator.platform == 'MacPPC')
		|| (navigator.platform == 'Macintosh') || (navigator.platform == 'MacIntel');
	OSArray.iphone = UserAgent.indexOf('iPhone') > -1;
	OSArray.ipod = UserAgent.indexOf('iPod') > -1;
	OSArray.ipad = UserAgent.indexOf('iPad') > -1;
	OSArray.Android = UserAgent.indexOf('Android') > -1;
	for (var i in OSArray) {
		if (OSArray[i]) {
			OS = i;
		}
	}
	return OS;
};

export const base64ToBlob = (dataUrl) => {
    let arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
};

/**
 * 上传图片到天翼云 ZOS
 * @param {File} file - 图片文件
 * @param {string} folder - 上传文件夹路径，默认 'report/images'
 * @returns {Promise} - 返回 Promise，resolve 时返回图片 URL
 */
export const uploadToZOS = (file, folder) => {
	if (!folder) folder = 'report/images';
	
	return new Promise((resolve, reject) => {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('folder', folder);

		const url = pcUrl('/common/upload/zos');
		
		httpPost(url, formData, 'POST', { rawResponse: true })
			.then(response => {
				let imageUrl = '';
				
				// 从 response.data.url 获取图片地址
				if (response && response.data && response.data.url) {
					imageUrl = response.data.url;
				}
				
				if (imageUrl) {
					resolve(imageUrl);
				} else {
					reject(new Error('上传失败：未获取到图片URL'));
				}
			})
			.catch(error => {
				console.error('天翼云ZOS上传失败:', error);
				reject(error);
			});
	});
};

